import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { BuyboxRegularOffer } from '@/features/buybox/types/types';

const providersFR = [
	350, 119, 381, 2, 337, 283, 1853, 2330, 677, 1875, 444, 239, 1796, 8, 201, 262, 296, 582, 588, 685, 688, 1732, 2472,
	1733, 1734, 1735, 1736, 1737, 1738, 1887, 1888, 1889, 1968, 2173, 2358, 2428, 10, 554, 2478, 415, 234, 59, 58, 345,
	2144, 324, 2140, 692, 190, 569, 475, 701, 542, 138, 559, 236, 3, 223, 315, 2285, 464, 310, 2145, 147, 551, 1899, 68,
	2139, 1967, 11, 61, 531, 2303, 300, 2307, 35, 193, 513, 1715, 309, 1771, 550, 1754, 567, 2210, 1860, 2286, 546, 192,
	188, 538, 1945, 2077,
];

const providersIT = [
	350, 119, 2, 1853, 337, 29, 39, 283, 696, 677, 444, 201, 262, 296, 582, 584, 607, 688, 689, 708, 1710, 1726, 1727,
	1728, 1729, 1730, 1894, 1895, 1896, 1897, 1968, 2108, 2141, 2243, 2275, 2358, 2388, 2389, 1796, 8, 2330, 10, 234,
	554, 2149, 2110, 692, 190, 524, 569, 475, 701, 559, 2478, 3, 100, 223, 315, 110, 2285, 464, 551, 359, 68, 11, 641,
	2111, 531, 300, 222, 35, 1715, 2112, 309, 1771, 2109, 109, 567, 2113, 546, 188, 538,
];

const providersES = [
	350, 119, 2, 283, 337, 2472, 1773, 2241, 149, 2474, 1854, 196, 201, 262, 296, 528, 607, 608, 684, 689, 1739, 1740,
	1741, 1742, 1743, 1890, 1968, 2141, 2243, 2275, 2358, 2393, 10, 63, 64, 1717, 393, 444, 257, 1970, 1796, 8, 2330,
	677, 2478, 1771, 2237, 2034, 234, 62, 554, 2127, 2124, 692, 190, 569, 475, 701, 559, 3, 100, 223, 315, 2285, 2119,
	464, 551, 68, 456, 11, 2121, 2122, 300, 35, 541, 1875, 1715, 309, 1838, 567, 546, 1899, 188, 538,
];

const providersMX = [
	350, 119, 337, 1853, 2142, 2107, 2, 283, 464, 692, 444, 1860, 2330, 677, 8, 1796, 568, 608, 1771, 190, 201, 262,
	300, 309, 315, 339, 457, 467, 473, 475, 531, 546, 551, 554, 559, 569, 3, 10, 11, 66, 68, 73, 100, 167, 188, 567,
	582, 683, 689, 690, 701, 1715, 1825, 1866, 1875, 1889, 1899, 1968, 2106, 2141, 2158, 2160, 2161, 2162, 2163, 2165,
	2166, 2167, 2243, 2285, 2303, 2356, 2472, 2478, 35, 541, 1875, 1715, 309, 1838, 567, 546, 188, 538,
];

const providersBR = [
	350, 119, 337, 1853, 2142, 2107, 2, 283, 1973, 692, 2330, 677, 444, 8, 1796, 2285, 112, 1975, 1978, 2212, 2221,
	2222, 2228, 201, 262, 300, 307, 309, 315, 447, 464, 473, 475, 477, 484, 499, 531, 544, 546, 551, 562, 3, 10, 11, 19,
	47, 68, 167, 190, 554, 559, 567, 569, 582, 608, 683, 701, 1715, 1771, 1825, 1860, 1861, 1875, 1899, 1920, 1968,
	2106, 2141, 2156, 2157, 2158, 2159, 2160, 2243, 2303, 2356, 2472, 2478, 2488, 538, 1945, 2077,
];

const providersDE = [
	350, 9, 304, 30, 2, 1853, 2035, 2038, 2037, 337, 298, 29, 2137, 10, 283, 582, 584, 597, 607, 679, 693, 708, 1707,
	1713, 2233, 2247, 2256, 2259, 2266, 2273, 2277, 2289, 2291, 2293, 2296, 2297, 2298, 2299, 2359, 2481, 286, 678, 680,
	681, 686, 687, 706, 707, 1706, 1709, 1710, 1711, 1712, 1741, 1757, 1788, 1805, 1806, 1891, 1892, 1968, 1989, 2063,
	2065, 2134, 2141, 2173, 2227, 2229, 2231, 2243, 2244, 2246, 2249, 2250, 2252, 2253, 2255, 2257, 2258, 2260, 2261,
	2263, 2264, 2265, 2267, 2268, 2269, 2270, 2271, 2272, 2274, 2279, 2287, 2288, 2292, 2294, 2295, 2319, 2357, 2358,
	2362, 201, 262, 285, 296, 334, 2245, 2248, 2251, 2254, 2262, 2278, 2280, 2290, 2360, 2526, 178, 68, 133, 1756, 341,
	344, 677, 2330, 100, 130, 175, 188, 190, 192, 219, 223, 234, 300, 309, 315, 444, 2125, 2131, 2136, 2138, 3, 8, 11,
	20, 28, 33, 35, 310, 349, 389, 415, 421, 464, 475, 479, 480, 481, 498, 522, 524, 531, 533, 537, 542, 546, 551, 554,
	559, 562, 567, 569, 613, 692, 701, 1715, 1722, 1723, 1764, 1771, 1796, 1829, 1902, 1954, 1958, 1993, 1994, 2076,
	2081, 2100, 2103, 2201, 2206, 2207, 2209, 2211, 2220, 2281, 2285, 2412, 2478, 538, 1945, 2077,
];

const providersGB = [
	350, 9, 613, 2100, 337, 2034, 2041, 2047, 642, 1853, 2060, 2, 283, 529, 29, 2471, 1893, 2164, 2296, 2467, 1968,
	2141, 2172, 2262, 2264, 2266, 2273, 2316, 2317, 2323, 2325, 2362, 2390, 2392, 2406, 2420, 2428, 2429, 2448, 2066,
	2243, 600, 296, 582, 584, 596, 602, 1747, 1757, 287, 595, 597, 598, 599, 603, 604, 607, 688, 689, 690, 1, 710, 1,
	744, 1745, 1746, 197, 199, 201, 205, 196, 204, 2068, 2274, 2275, 2278, 2290, 2314, 2321, 2324, 2426, 2440, 8, 175,
	1796, 2330, 677, 444, 10, 692, 1793, 73, 87, 99, 100, 103, 130, 137, 188, 189, 190, 192, 223, 224, 234, 300, 1771,
	2128, 2130, 2132, 2143, 2198, 2480, 3, 11, 35, 38, 39, 41, 68, 309, 315, 333, 432, 445, 464, 473, 475, 524, 531,
	546, 551, 554, 559, 567, 569, 591, 593, 615, 701, 1, 715, 1875, 2285, 2300, 2303, 2304, 2311, 2478, 538,
];

const providersCA = [
	283, 350, 119, 2100, 2, 2048, 2034, 2039, 2056, 2044, 2049, 2243, 294, 1794, 196, 612, 197, 2171, 1968, 584, 2395,
	296, 705, 608, 588, 582, 2430, 204, 609, 606, 2158, 205, 605, 611, 689, 528, 610, 2390, 587, 2358, 607, 589, 337,
	257, 692, 10, 1854, 1852, 2052, 1853, 2417, 8, 175, 1796, 444, 2330, 182, 212, 326, 2285, 230, 300, 449, 531, 140,
	68, 73, 469, 146, 344, 314, 258, 516, 192, 11, 305, 559, 331, 526, 430, 1985, 2303, 3, 520, 2304, 223, 525, 309,
	151, 99, 441, 1957, 1960, 315, 427, 446, 2478, 1715, 1972, 701, 25, 514, 1875, 546, 87, 143, 464, 532, 2525, 188,
	581, 529, 433, 488, 579, 677, 100, 551, 554, 475, 190, 550, 569, 567, 1771, 2097, 2096, 2099, 2105, 2098, 538,
];

const providersAR = [
	350, 119, 337, 2107, 692, 2, 1853, 283, 8, 444, 2330, 1899, 300, 2285, 339, 167, 531, 2302, 1875, 491, 11, 2478,
	575, 3, 559, 467, 2106, 546, 701, 1715, 1860, 677, 551, 309, 567, 190, 569, 315, 554, 475, 689, 1771, 457, 538,
];

const providersUS = [
	350, 9, 15, 2, 283, 257, 2383, 337, 386, 531, 2061, 2055, 2058, 2036, 1853, 1854, 1852, 2050, 2057, 2040, 2033,
	2044, 2060, 2047, 2048, 2045, 2056, 1855, 2039, 2049, 2059, 196, 293, 600, 2377, 2428, 2473, 688, 2376, 2317, 2369,
	2360, 2068, 2071, 2398, 598, 2429, 2262, 2273, 2446, 197, 201, 2400, 2367, 2415, 2408, 295, 1890, 2322, 2379, 2364,
	2401, 2329, 262, 2425, 582, 528, 2445, 583, 584, 2243, 2418, 199, 2326, 2407, 602, 2432, 2465, 2435, 2365, 2442,
	1825, 2390, 1794, 1968, 294, 2430, 343, 289, 204, 2475, 2413, 2296, 287, 202, 2174, 290, 2266, 2066, 291, 2441,
	2474, 2433, 597, 2427, 2406, 1811, 2073, 2172, 2315, 2318, 2395, 2089, 2164, 2403, 2434, 2444, 2371, 2470, 2420,
	2327, 2414, 2419, 2423, 2431, 2378, 2467, 2438, 2466, 2064, 2405, 2392, 2404, 2448, 2494, 2437, 2366, 2443, 2325,
	2417, 2472, 690, 2316, 263, 2468, 2436, 2275, 205, 2320, 2323, 2396, 2274, 2285,
];

const buyboxSortingCountries = ['FR', 'IT', 'ES', 'MX', 'BR', 'DE', 'GB', 'CA', 'AR', 'US'] as const;

type buyboxSortingCountry = (typeof buyboxSortingCountries)[number];

export function isSortedBuyboxCountry(country: string): country is buyboxSortingCountry {
	return buyboxSortingCountries.includes(country as buyboxSortingCountry);
}

export const sortedBuyboxProvidersByCountry: Record<buyboxSortingCountry, number[]> = {
	FR: providersFR,
	IT: providersIT,
	ES: providersES,
	MX: providersMX,
	BR: providersBR,
	DE: providersDE,
	GB: providersGB,
	CA: providersCA,
	AR: providersAR,
	US: providersUS,
};

export function sortBuyboxOffers(offers: BuyboxRegularOffer[], country: string, isLoggedIn: boolean) {
	if (!isSortedBuyboxCountry(country) || isLoggedIn) return offers;

	const provider_ids_sorted = sortedBuyboxProvidersByCountry[country];

	return offers.slice().sort((a, b) => {
		const indexA = provider_ids_sorted.indexOf(a.package.packageId);
		const indexB = provider_ids_sorted.indexOf(b.package.packageId);

		if (indexA === -1 && indexB === -1) return 0; // both not found
		if (indexA === -1) return 1; // a not found, b found
		if (indexB === -1) return -1; // a found, b not found

		return indexA - indexB;
	});
}

const isJustWatchTV = (offer: TitleOfferFragment) => offer.package.technicalName === 'justwatchtv';
export function sortJustWatchTVFirst(offerA: TitleOfferFragment, offerB: TitleOfferFragment) {
	// Number(true) = 1, Number(false) = 0
	return Number(isJustWatchTV(offerB)) - Number(isJustWatchTV(offerA));
}
